import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuditLog } from 'src/app/shared/models/AuditLog';
import { AuditLogPage } from 'src/app/shared/models/AuditLogPage';
import {AuthenticationService} from 'src/app/shared/services/authentication.service';
import {CurrentUserService} from 'src/app/shared/services/current-user.service';
import {UtilsService} from 'src/app/shared/services/utils.service';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuditService {

  constructor(
      private http: HttpClient,
      private utilsService: UtilsService,
      private authenticationService: AuthenticationService,
      private currentUserService: CurrentUserService
    ) {}

     private createAuditHeaders(): HttpHeaders {
        const currentUser = this.currentUserService.getCurrentUser() as any || {};
    
        const requestId = (typeof crypto !== 'undefined' && crypto.randomUUID)
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        const role = currentUser?.role ?? '';
        const displayName = currentUser.displayName ?? `${currentUser.firstName ?? ''} ${currentUser.lastName ?? ''}`.trim();
    
        return new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'X-User-Identifier': currentUser.identifier ?? '',
          'X-User-Display-Name': displayName,
          'X-User-Role': role,
          'X-Actor-Source': 'FE',
          'X-Request-ID': requestId
        });
      }
    
      get options() {
        return {
          headers: this.createAuditHeaders()
        };
      }

    getAuditHistory(entityType: string, entityId: string): Observable<AuditLog[]> {
          console.log(entityId);
          return this.http.get<AuditLog[]>(
            `${environment.backendApiUrl}/audit/${entityType}/${entityId}`,
            this.options
          );
        }
  
      private buildDateTime(dateValue: any, endOfDay = false): string | null {
        if (!dateValue) {
          return null;
        }

        let date: Date;
        if (typeof dateValue === 'string') {
          date = new Date(dateValue);
        } else if (dateValue instanceof Date) {
          date = dateValue;
        } else {
          return null;
        }

        if (isNaN(date.getTime())) {
          return null;
        }

        if (endOfDay) {
          date.setHours(23);
          date.setMinutes(59);
          date.setSeconds(59);
          date.setMilliseconds(999);
        }

        return date.toISOString();
      }
  
   getAllAuditLogs(filters: any): Observable<AuditLogPage> {

      const body: any = {
        page: filters.page,
        size: filters.size,

        sort: [
          {
            field: 'createdAt',
            direction: 'DESC'
          }
        ],

        filters: {}
      };

      // ✅ entityType
      if (filters.entityType && filters.entityType !== '') {
        body.filters.entityType = [filters.entityType];
      }

      // ✅ operation
      if (filters.operation && filters.operation !== '') {
        body.filters.operation = [filters.operation];
      }

      // ✅ role
      if (filters.role && filters.role !== '') {
        body.filters.actorRole = [filters.role];
      }

      // ✅ date range
      if (filters.dateFromISO || filters.dateToISO) {
        body.filters.dateRange = {
          from: this.buildDateTime(filters.dateFromISO, false),
          to: this.buildDateTime(filters.dateToISO, true)
        };
      }

      // ✅ clean si aucun filtre
      if (Object.keys(body.filters).length === 0) {
        delete body.filters;
      }

      return this.http.post<AuditLogPage>(
        environment.backendApiUrl + '/audit/search',
        body,
        this.options
      ).pipe(
        catchError(this.utilsService.handleError)
      );
    }

 getAuditLogsByApplications(body: any): Observable<AuditLogPage> {
    return this.http.post<AuditLogPage>(
        environment.backendApiUrl + '/audit/by-applications',
        body,
        this.options
    ).pipe(
        catchError(this.utilsService.handleError)
    );
}


    
    
}
